<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>اليومية</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم ادخال وعرض يومية الحسابات
              <div class='pull-left' style='padding=0px'>
                <button @click="newEntry()" type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px">
                <label>الفرع</label>
                <select  @change='UpdateData($event.target.value)' class="form-control" style="padding: 0px" v-model="branche_id">
                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px">
                <tbDate  :mytitle='dateTitle' v-model= 'dayDate' ></tbDate>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <label>المحصل:</label>
              <div class="form-group input-group">
                <span class="input-group-btn">
                  <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                    <button
                      @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                    </button>
                </span>
                <select class="form-control" style="padding: 0px" v-model="collector_id">
                  <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                    {{ collector.name }}
                  </option>
                </select>
                </div>
              </div>
              <div style="padding:29px 5px 5px 3px" class='col-lg-2 col-md-2 col-sm-6'>
                <button type='button'  @click='FillGrid()' class='btn btn-outline btn-primary btn-md btn-block ' >
                  <b> عرض </b>
                </button>
              </div>
              <br>
              <br>
              <br>
              <br>
              <div id="contentToPrint"  style="padding-top: 5px">
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الايصال</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>الحالة</th>
                      <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{fcolorgreen :record.status == 4,deleted :record.status == 3,fcolor :record.status == 1 || record.status == 5}" class='odd gradeX' v-for='(record,index) in records' :key='index'>

                      <td align='center'>{{index +1 }}</td>
                      <td align='center'>{{record.id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>
                        <button v-if="record.status == 2" @click='newEntry(record.id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal' >تسوية</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>إضافة عملية جديدة</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationModelErrors'>
                <ul v-if='validationModelErrors'>
                  <li v-for='err in validationModelErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationReceiptErrors'>
                  <ul v-if='validationReceiptErrors'>
                    <li v-for='err in validationReceiptErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                  </ul>
                </div>
                <div class="row" style="padding: 5px">
                  <div class='col-lg-2 col-md-2 col-sm-6' style="padding-left: 2px">
                    <label>الفرع</label>
                    <select style="padding: 0px" @change='UpdateData($event.target.value)' class="form-control"  v-model="branche_id">
                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 2px 2px 2px 10px">
                    <label>المحصل:</label>
                    <select class="form-control" @change="onChangeStore($event)" style="padding: 0px" v-model="technical_id">
                      <option v-for="store in collectors" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-2 col-md-2 col-sm-6' style="padding: 2px 2px 2px 2px">
                    <label>الخزنة:</label>
                    <select class="form-control" style="padding: 0px" v-model="treasury_id">
                      <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                        {{ treasury.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-2 col-md-2 col-sm-6' style="padding: 2px 2px 2px 2px">
                    <label>المخزن:</label>
                    <select class="form-control" @change="onChangeStore($event)" style="padding: 0px" v-model="store_id">
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 2px 2px 2px 10px">
                    <tbDate :today='today' :mytitle='dateTitle' v-model= 'dayDate' ></tbDate>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-6" style="padding: 15px 15px 0px 0px">
                    <div class="form-group input-group col-lg-12 col-md-12 col-sm-6">
                      <span class="input-group-addon">الايصال
                      </span>
                      <input style="padding: 3px" @keypress="isNumber($event)" ref="code" v-on:keypress="GetData($event)" v-model='recID' type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-8" style="padding: 0px;margin:0px">
                    <div v-if='alert_class || isLoadingRecData' style="padding-top: 15px;padding-right:0px">
                      <div  :class="alert_class" style="padding-top: 10px;height: 33px;margin:0px 0px 0px 13px;padding:5px ">
                        <vue-element-loading size='32' :active='isLoadingRecData' spinner='bar-fade-scale' color='#A4A4A4'/>
                        <div v-if="!CustomerDataErr">
                          <div v-if="!isLoadingRecData" class="col-lg-4 col-md-4 col-sm-4">
                            <b>  الكود: </b>  {{record.rec_id}}
                          </div>
                          <div v-if="!isLoadingRecData" class="col-lg-7 col-md-7 col-sm-7" style="padding:0px">
                            <b>الاسم: </b>  {{record.name}}
                          </div>
                          <div v-if="!isLoadingRecData" class="col-lg-1 col-md-1 col-sm-1" style="padding:0px">
                            <button @click='openCustomerData(record.uid, record)' type='button' class='btn btn-success btn-xs btn-block'>فتح</button>
                          </div>
                        </div>
                        <div v-if="CustomerDataErr">
                          {{CustomerDataErr}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-4" style="padding: 15px 0px 0px 10px">
                    <div class="form-group input-group col-lg-12 col-md-12 col-sm-6">
                      <span class="input-group-addon">TDS
                      </span>
                      <input style="padding: 3px" @keypress="isNumber($event)" v-model='tds' type="text" class="form-control">
                    </div>
                  </div>
                </div>
                <div class='col-lg-6 col-md-6' >
                  <div class='col-lg-12 col-md-12 col-sm-12' style='padding: 0px 3px 0px 0px;'>
                    <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='offerValidationErrors'>
                      <ul>
                        <li v-for='err in offerValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                      </ul>
                    </div>
                    <label >العرض:</label>
                    <div @change="changeOffer()" class="col-lg-12 col-sm-12 form-group input-group"  style='padding: 0px;margin:0px'>
                      <span class="input-group-btn">
                        <button :disabled="isAddDisabled" @click="addToReceiptItemSheet()" class="btn btn-default" type="button"><i class="fa fa-plus" style="color:green"></i>
                        </button>
                      </span>
                      <select class="form-control" style="padding: 0px" v-model="offer_id">
                        <option v-for="item in offers" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.offer_name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class='col-lg-4 col-md-4 col-sm-4' style='padding: 0px 0px 10px 2px;'>
                    <label>نوع العقد:</label>
                    <select style="padding: 0px" @change="changeOffer()" class="form-control" v-model="offer_type">
                      <option value='1'>كاش</option>
                      <option value='0'>تقسيط</option>
                      <option value='2'>هدية</option>
                    </select>
                  </div>
                  <div class="col-lg-2 col-sm-2" style='padding: 0px 0px 10px 3px;'>
                    <label >المبلغ:</label>
                    <input disabled ref="offerPrice" :value='offerPrice' class='form-control' type='text'>
                  </div>
                  <div class="col-lg-2 col-sm-2" style='padding: 0px 0px 10px 3px;'>
                    <label>الخصم:</label>
                    <input @keypress="isNumber($event)"  v-on:input='UpdatePrice()' v-model='contractOfferDiscount' class='form-control' name='amount' type='text'>
                  </div>
                  <div class="col-lg-2 col-sm-2" style='padding: 0px 0px 10px 3px;'>
                    <label>المطلوب:</label>
                    <input disabled :value='contractOfferAmount' class='form-control' name='amount' type='text'>
                  </div>
                  <div class="col-lg-2 col-sm-2" style='padding: 0px 0px 10px 3px;'>
                    <label>المدفوع:</label>
                    <input  :disabled="offer_type == 1" @keypress="isNumber($event)"  v-on:input='UpdatePrice()' v-model='contractOfferPresenter' class='form-control' name='amount' type='text'>
                  </div>
                  <div v-if="offer_type == 0" class="col-lg-2 col-sm-2" style='padding: 0px 0px 10px 3px;'>
                    <label>الباقى:</label>
                    <input  disabled @keypress="isLocked($event)" v-model='contractOfferrest' class='form-control' name='amount' type='text'>
                  </div>
                  <div v-if="offer_type == 0" class="col-lg-3 col-sm-3" style='padding: 0px 0px 10px 3px;'>
                    <label>عدد الاقساط:</label>
                    <select class="form-control" style="padding: 0px" v-model="contractOfferInstallmentCount">
                      <option v-for="n in 10" :key="n" :value="n">
                        {{ n }}
                      </option>
                    </select>
                  </div>
                  <div v-if="offer_type == 0" class='col-lg-3 col-sm-3' style='padding: 0px 0px 10px 3px;'>
                    <label>قيمة القسط:</label>
                    <input @keypress="isNumber($event)" v-model='contractOfferInstallment' class='form-control' name='amount' type='text'>
                  </div>
                  <div v-if="offer_type == 0" class='col-lg-4 col-sm-4' style='padding: 0px 0px 10px 3px;'>
                    <label>فترة السداد:</label>
                    <select class="form-control" style="padding: 0px" v-model="contractOfferPeriodMonthly">
                      <option v-for="item in periodMonthlyType" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div v-if="offer_type == 0" class='col-lg-4 col-sm-4' style='padding: 0px 0px 5px 3px;'>
                    <tbDate :mytitle='installmentDateTitle' v-model= 'installmentDate' ></tbDate>
                  </div>
                  <div class='col-lg-8 col-sm-8' style='padding: 0px 0px 5px 3px;'>
                    <label>المفوض:</label>
                    <select class="form-control" style="padding: 0px" v-model="offer_teller_user_id">
                      <option v-for="item in delegates" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="row unselectable" style="padding: 15px 18px 0px 18px;">
                    <table width='100%' class='table table-striped table-bordered table-hover' >
                      <thead>
                        <tr>
                          <th style='padding:2px;text-align: center'></th>
                          <th style='padding:2px;text-align: center'>البيــــان</th>
                          <th style='padding:2px;text-align: center'>التسعير</th>
                          <th style='padding:2px;text-align: center'>السعر</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class='odd gradeX' v-for='(record) in receiptItemSheet' :key='record.id'>
                          <td style='padding:2px;text-align: center'><a @click='removeItem(record, 1)' v-show="record.type === 1" style="padding: 0px" class="btn btn-social-icon btn-bitbucket"><i class="fa fa-times" style="color:red"></i></a></td>
                          <td style='padding:2px;text-align: center'>{{record.label}}</td>
                          <td style='padding:2px;text-align: center'>{{record.price_type}}</td>
                          <td style='padding:2px;text-align: center'>{{record.price}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class='col-lg-6 col-md-6' style='padding:0px 10px 0px 18px;'>
                  <div class='col-lg-4 col-md-4 col-sm-4' style='padding: 0px 0px 10px 10px;'>
                    <label >النوع:</label>
                    <select style="padding: 0px" ref="price_type" class="form-control" v-model="itemsPriceType">
                      <option v-for="item in price_types" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name}}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-3 col-md-3 col-sm-3' style='padding: 0px 0px 10px 10px;'>
                    <label >ك.الصنف:</label>
                    <input ref="maintenanceItems" v-on:keypress="newItems_keypress($event)" v-model='newItems' class='form-control' type='text'>
                  </div>
                  <div class='col-lg-2 col-md-2 col-sm-2' style='padding: 0px 0px 10px 10px;'>
                    <label >السعر:</label>
                    <input @keypress="isNumber($event)" ref="price" v-on:keypress="price_keypress($event)" v-model='price' class='form-control' type='text'>
                  </div>
                  <div class='col-lg-3 col-md-3 col-sm-32' style='padding: 0px 0px 10px 0px;'>
                    <label >المدفوع:</label>
                    <input @keypress="isNumber($event)" ref="paid" v-on:keypress="paid_keypress($event)" v-model='paid' class='form-control' type='text'>
                  </div>
                  <div class="row unselectable" style="padding: 15px 18px 0px 18px;">
                    <table width='100%' class='table table-striped table-bordered table-hover' >
                      <thead>
                        <tr>
                          <th style='padding:2px;text-align: center'></th>
                          <th style='padding:2px;text-align: center' data-toggle="tooltip" data-placement="top" :title="record.tooltip">الصنف</th>
                          <th style='padding:2px;text-align: center'>النوع</th>
                          <th style='padding:2px;text-align: center'>السعر</th>
                          <th style='padding:2px;text-align: center'>المدفوع</th>
                          <th style='padding:2px;text-align: center'><input @click="selectDelivery($event.target.value)" v-model="selectedDelivery" type="checkbox" value=""> <i class="fa fa-truck" style="color:blue"> </i></th>
                          <th style='padding:2px;text-align: center'><input @click="selectInstallation($event.target.value)" v-model="selectedInstallation" type="checkbox" value=""> <i class="fa fa-wrench" style="color:blue"> </i></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class='odd gradeX' v-for='(record) in receiptItems' :key='record.id'>
                          <td style='padding:2px;text-align: center'><a @click='removeItem(record, 0)' v-show="record.type !== 1" style="padding: 0px" class="btn btn-social-icon btn-bitbucket"><i class="fa fa-times" style="color:red"></i></a></td>
                          <td :style="record.isContractMaintenanceItems.id ?'color:green;':'color:#000000;' " style='padding:2px;text-align: center' data-toggle="tooltip" data-placement="top" :title="record.isContractMaintenanceItems.offer_name" v-on:click="isOk(record)">{{record.item}}</td>
                          <td :style="record.isContractMaintenanceItems.isOk ?'color:green;':'color:#000000;' " style='padding:2px;text-align: center'>{{record.price_type}}</td>
                          <td :style="record.isContractMaintenanceItems.isOk ?'color:green;':'color:#000000;' " style='padding:2px;text-align: center'>{{record.price}}</td>
                          <td :style="record.isContractMaintenanceItems.isOk ?'color:green;':'color:#000000;' " style='padding:2px;text-align: center'>{{record.paid}}</td>
                          <td style='padding:2px;text-align: center'><input type="checkbox" :id="record.id" @click="selectItemDelivery($event.target.value, record.id)" v-model="record.delivery" :value="record.delivery"></td>
                          <td style='padding:2px;text-align: center'><input type="checkbox" :id="record.id" @click="selectItemInstallation($event.target.value, record.id)" v-model="record.Installation" :value="record.Installation"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-lg-12 col-sm-12"  style="padding: 0px 15px 0px 15px">
                  <!--
                  <div class="col-lg-2 col-sm-2" style="padding: 3px" >
                    <label>م صيانة:</label>
                    <input @keypress="isLocked($event)" v-model='val1' class='form-control' name='amount' type='text'>
                  </div>
                -->
                  <div class="col-lg-2 col-sm-2" style="padding: 3px" >
                    <label>سداد:</label>
                    <input  @keypress="isNumber($event)"  v-model='installment' class='form-control' name='amount' type='text'>
                  </div>
                  <div class="col-lg-2 col-sm-2" style="padding: 3px" >
                    <label>تحصيل:</label>
                    <input  @keypress="isNumber($event)"  v-model='receipt' class='form-control' name='amount' type='text'>
                  </div>
                  <!--
                  <div class='col-lg-5 col-sm-5' style="padding: 3px" >
                    <label>العرض:</label>
                    <select class="form-control" style="padding: 0px" v-model="contract_offer_id">
                      <option  v-for="offer in contract_offers" v-bind:key="offer.id"  v-bind:value="offer.id">
                        {{offer.date}} => {{offer.offer_name}} [{{offer.state_title}}]
                      </option>
                    </select>
                  </div>
                  -->
                  <div class="col-lg-2 col-sm-2" style="padding: 3px" >
                    <label>&nbsp;</label>
                    <button @click='saveData()' type='button' class='btn btn-success  btn-block'>حفظ</button>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='newEntry()' type='button' class='btn btn-primary'>جديد</button>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
      <!-- ================ Contracts Modal Begin ======================================== -->
      <CustomerDetails ref="CustomerDetails"  @return-data="returnDataCustomer"> </CustomerDetails>
    <!-- ================  /.modal-content ======================================== -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->

  </div>
</template>
<style>
.fcolor {
   color: #FF0000;
}
.fcolorgreen {
   color: #0BB21A;
}
.deleted {
  text-decoration: line-through;
}
</style>
<style>
  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
<script>
import axios from 'axios'
import moment from 'moment'
import tbDate from '@/components/myComponents/tbDate'
import CustomerDetails from '@/components/Sales/Customers/CustomerDetails'
export default {
  components: {
    tbDate,
    CustomerDetails
  },
  name: 'dailyaccounts',
  data () {
    return {
      folderDate: '',
      contract_offers: '',
      contract_offer_id: 0,
      contractOfferPeriodMonthly: null,
      contractOfferInstallment: null,
      contractOfferrest: null,
      contractOfferDiscount: null,
      offerPrice: 0,
      price: 0,
      paid: 0,
      tds: '',
      isgetTec: false,
      receipt: 0,
      installment: 0,
      ContractMaintenanceItems: '',
      contractOfferPresenter: 0,
      contract_id: '',
      teller_user_id: '',
      offer_teller_user_id: '',
      validationReceiptErrors: '',
      technical_id: '',
      selectedDelivery: true,
      selectedInstallation: true,
      installmentDate: null,
      contractOfferID: '',
      offers: [],
      delegates: [],
      price_types: [
        {id: 1, name: 'كاش'},
        {id: 2, name: 'قسط'},
        {id: 3, name: 'مستعمل'},
        {id: 4, name: 'ضمان'},
        {id: 5, name: 'هدية'},
        {id: 0, name: 'عرض سابق'}
      ],
      periodMonthlyType: [
        {id: null, name: ''},
        {id: 1, name: 'شهرى'},
        {id: 2, name: 'كل شهرين'},
        {id: 3, name: 'كل 3 شهور'},
        {id: 4, name: 'كل أربع شهور'}
      ],
      val1: 0,
      offer_id: '',
      offer_type: 1,
      itemsPriceType: 1,
      newItems: '',
      receiptItemSheet: [],
      receiptItems: [],
      branches: {},
      branche_id: '',
      offerValidationErrors: '',
      total_maintenance: 0,
      cach_type: '',
      price_type: 1,
      treasuries: {},
      treasury_id: '',
      collectors: {},
      collector_id: '',
      today: true,
      dateTitle: 'التاريخ',
      installmentDateTitle: 'أول قسط',
      dayDate: '',
      CustomerDataErr: '',
      validationErrors: '',
      validationModelErrors: '',
      itemsPriceTypeStr: '',
      records: {},
      record: {},
      recID: null,
      code: null,
      stores: {},
      items: {},
      alert_class: null,
      contractOfferInstallmentCount: null,
      isLoadingRecData: false,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      contractOfferAmount: 0,
      title: '',
      store_name: '',
      emp: '',
      store_id: '',
      // ----------------------
      offer: ''
    }
  },
  // =====================================================
  computed: {
    isAddDisabled () {
      if (parseInt(this.offer_type) === 0) {
        return (
          !this.offer_id ||
          this.offer_id === 0 ||
          !this.offer_teller_user_id ||
          this.offer_teller_user_id === 0 ||
          this.contractOfferInstallmentCount === 0 ||
          !this.contractOfferInstallmentCount ||
          Number(this.contractOfferInstallment) === 0 ||
          !this.contractOfferInstallment ||
          this.contractOfferPeriodMonthly === 0 ||
          !this.contractOfferPeriodMonthly ||
          this.contractOfferrest === 0 ||
          !this.contractOfferrest ||
          !moment(this.installmentDate, 'YYYY-MM-DD', true).isValid() ||
          this.contractOfferrest < 1
        )
      } else {
        return (
          !this.offer_id ||
          this.offer_id === 0 ||
          !this.offer_teller_user_id ||
          this.offer_teller_user_id === 0
        )
      }
    }
  },
  // =====================================================
  created () {
    this.record = ''
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche_id = this.branches[0].id
    this.UpdateData(this.branche_id)
    this.getItems()
    this.getOffres()
  },
  methods: {
    newEntry (id) {
      this.installmentDate = null
      this.contractOfferPeriodMonthly = null
      this.contractOfferInstallmentCount = null
      this.contractOfferID = ''
      this.contractOfferPeriodMonthly = null
      this.contractOfferInstallment = null
      this.contractOfferrest = null
      this.contractOfferDiscount = null
      this.contractOfferAmount = 0
      this.offerPrice = ''
      this.tds = ''
      this.price = 0
      this.paid = 0
      this.ContractMaintenanceItems = ''
      this.itemsPriceTypeStr = ''
      this.contract_id = ''
      this.customer_id = ''
      this.teller_user_id = ''
      this.offer_teller_user_id = ''
      this.validationReceiptErrors = ''
      this.val1 = 0
      this.installment = 0
      this.receipt = 0
      this.contractOfferPresenter = 0
      this.offer_id = ''
      this.newItems = ''
      this.receiptItemSheet = ''
      this.record = ''
      this.receiptItems = ''
      this.contract_offer_id = 0
      this.$refs.code.focus()
      if (parseInt(id) > 0) {
        this.recID = id
        this.getReceiptData()
      }
    },
    // ========================================================
    newOffer () {
      this.installmentDate = null
      this.contractOfferID = ''
      this.contractOfferPeriodMonthly = null
      this.contractOfferInstallment = null
      this.contractOfferrest = 0
      this.offerPrice = ''
      this.contractOfferPresenter = 0
    },
    // ========================================================
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.collectors = ''
        this.stores = this.branches[i].stores
        this.delegates = this.branches[i].delegates
      }
      this.getItems()
    },
    // ============================================================
    UpdatePrice () {
      if (parseInt(this.offerPrice || 0) - parseInt(this.contractOfferDiscount || 0) < 0) {
        this.contractOfferDiscount = this.offerPrice
      }
      this.contractOfferAmount = parseInt(this.offerPrice || 0) - parseInt(this.contractOfferDiscount || 0)
      if (parseInt(this.offer_type) === 1) {
        this.contractOfferPresenter = parseInt(this.offerPrice || 0) - parseInt(this.contractOfferDiscount || 0)
      } else {
        this.contractOfferrest = parseInt(this.contractOfferAmount || 0) - parseInt(this.contractOfferPresenter || 0)
      }
    },
    // ========================================================
    getTec () {
      this.isgetTec = true
      axios.post(this.$apiURL + 'get-folder-tec', {
        token: localStorage.getItem('token'),
        branch_id: this.branche_id,
        folder_date: this.dayDate
      })
        .then(({ data }) => {
          this.collectors = data
          this.isgetTec = false
        })
        .catch(err => {
          if (err) {
            this.isgetTec = false
          }
        })
    },
    // ========================================================
    changeOffer () {
      const i = this.offers.findIndex(x => x.id === parseInt(this.offer_id))
      this.contractOfferDiscount = 0
      this.contractOfferInstallment = null
      this.contractOfferPeriodMonthly = null
      this.contractOfferInstallmentCount = null
      this.installmentDate = null
      this.contractOfferrest = 0
      if (parseInt(this.offer_type) === 1) {
        this.offerPrice = this.offers[i].price
        this.contractOfferPresenter = this.offers[i].price
        this.contractOfferAmount = this.offers[i].price
      } else if (parseInt(this.offer_type) === 0) {
        this.offerPrice = this.offers[i].installment_price
        this.contractOfferPresenter = 0
        this.contractOfferrest = this.offers[i].installment_price
        this.contractOfferAmount = this.offers[i].installment_price
      } else {
        this.offerPrice = 0
        this.contractOfferPresenter = 0
        this.contractOfferAmount = 0
      }
    },
    // ========================================================
    addToReceiptItemSheet () {
      this.offerValidationErrors = []
      var isError = false
      if (parseInt(this.offer_type) === 0) {
        if (parseInt(this.contractOfferPresenter) >= parseInt(this.offerPrice)) {
          this.offerValidationErrors.push('يجب ان يكون المدفوع اقل من المبلغ فى العقود القسط')
          isError = true
        }
        if (parseInt(this.contractOfferInstallment) > parseInt(this.contractOfferrest)) {
          this.offerValidationErrors.push('يجب ان يكون قيمة القسط اقل من المبلغ الباقى')
          isError = true
        }
        if (parseInt(this.contractOfferInstallment) === 0 || this.contractOfferInstallment === null || this.contractOfferInstallment === '') {
          this.offerValidationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        if (this.contractOfferPeriodMonthly === null) {
          this.offerValidationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.installmentDate, 'YYYY-MM-DD', true).isValid()) {
          this.offerValidationErrors.push('يجب ادخال تاريخ اول قسط بشكل صحيح مثلا 01-01-2028')
          isError = true
        }
      } else {
        if (parseInt(this.contractOfferInstallment) > 0) {
          this.offerValidationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (this.contractOfferPeriodMonthly > 0) {
          this.offerValidationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (this.installmentDate !== '' && this.installmentDate !== null) {
          this.offerValidationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
        if (parseInt(this.contractOfferrest) > 0) {
          this.offerValidationErrors.push('خطأ فى نوع العقد')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      this.offerValidationErrors = ''
      // ---------------------------------------------------------------
      var newRec = []
      var priceType = ''
      var receiptItemId = ''
      var label = ''
      var i = ''
      i = this.offers.findIndex(x => x.id === parseInt(this.offer_id))
      label = this.offers[i].label
      if (parseInt(this.offer_type) === 1) {
        priceType = 'كاش'
      } else if (parseInt(this.offer_type) === 0) {
        priceType = 'قسط'
      } else {
        priceType = 'هدية'
      }
      receiptItemId = Math.round(Math.random() * 10000000)
      newRec[newRec.length] = {}
      newRec[newRec.length - 1].id = receiptItemId
      newRec[newRec.length - 1].label = label
      newRec[newRec.length - 1].installment_period_monthly = this.contractOfferPeriodMonthly
      newRec[newRec.length - 1].installment = this.contractOfferInstallment
      newRec[newRec.length - 1].installment_data = this.installmentDate
      newRec[newRec.length - 1].contract_paid = this.contractOfferPresenter
      newRec[newRec.length - 1].contract_rec_id = this.contractOfferID
      newRec[newRec.length - 1].type = 1
      newRec[newRec.length - 1].price = this.offerPrice
      newRec[newRec.length - 1].price_type = priceType
      newRec[newRec.length - 1].price_type_id = this.offer_type
      newRec[newRec.length - 1].rec_id = this.offers[i].id
      newRec[newRec.length - 1].offer_teller_user_id = this.offer_teller_user_id
      newRec[newRec.length - 1].presenter_date = this.dayDate
      newRec[newRec.length - 1].installment_count = this.contractOfferInstallmentCount
      newRec[newRec.length - 1].discount = this.contractOfferDiscount
      newRec[newRec.length - 1].amount = this.contractOfferAmount
      newRec[newRec.length - 1].rest = this.contractOfferrest
      // -------------------------------------
      this.receiptItemSheet.unshift(newRec[0])
      let id = 0
      for (let r = 0; r < this.offers[i].offer_items.length; r++) {
        for (let c = 0; c < this.offers[i].offer_items[r].item_pieces; c++) {
          id++
          newRec = []
          newRec[newRec.length] = {}
          newRec[newRec.length - 1].id = receiptItemId + id
          newRec[newRec.length - 1].Installation = 1
          newRec[newRec.length - 1].type = 1
          newRec[newRec.length - 1].delivery = 1
          newRec[newRec.length - 1].item = this.offers[i].offer_items[r].item
          newRec[newRec.length - 1].item_id = this.offers[i].offer_items[r].item_id
          newRec[newRec.length - 1].price = 'عرض'
          newRec[newRec.length - 1].price_type = 'عرض'
          newRec[newRec.length - 1].price_type_id = 0
          newRec[newRec.length - 1].receipt_item_id = receiptItemId
          newRec[newRec.length - 1].isContractMaintenanceItems = []
          this.receiptItems.unshift(newRec[0])
        }
      }
      newRec = []
      this.newOffer()
    },
    // ======================================================
    isOk (Rec) {
      let isOk = ''
      if (Rec.isContractMaintenanceItems.isOk === 0) {
        isOk = 1
      }
      if (Rec.isContractMaintenanceItems.isOk === 1) {
        isOk = 0
      }
      let y = this.receiptItems.map(record => record.id).indexOf(Rec.id)
      if (y > -1) {
        this.receiptItems[y].isContractMaintenanceItems.isOk = isOk
      }
    },
    // ======================================================
    getOffres () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAllActiveOffers', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.offers = data
          this.isLoadingData = false
        })
    },
    // ======================================================
    setPrice () {
      var arr = this.newItems.split('-')
      if (Array.isArray(arr) && arr.length === 1) {
        let y = this.items.findIndex(x => x.item_id === parseInt(arr[0]))
        if (y > -1) {
          if (parseInt(this.itemsPriceType) === 1) {
            this.price = this.items[y].price
            this.itemsPriceTypeStr = 'كاش'
          } else if (parseInt(this.itemsPriceType) === 2) {
            this.price = this.items[y].installment_price
            this.itemsPriceTypeStr = 'قسط'
          } else if (parseInt(this.itemsPriceType) === 3) {
            this.price = this.items[y].warranty_price
            this.itemsPriceTypeStr = 'مستعمل'
          } else if (parseInt(this.itemsPriceType) === 4) {
            this.price = 0
            this.itemsPriceTypeStr = 'ضمان'
          } else if (parseInt(this.itemsPriceType) === 5) {
            this.price = 0
            this.itemsPriceTypeStr = 'هدية'
          } else {
            this.price = 0
            this.itemsPriceTypeStr = 'عرض'
          }
        }
        // this.addToReceiptItems()
      }
    },
    // ======================================================
    newItems_keypress (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        evt.preventDefault()
        this.getItemPrice()
      } else if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ======================================================
    price_keypress (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.$refs.paid.select()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ======================================================
    paid_keypress (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.addToReceiptItems()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ======================================================
    getItemPrice () {
      let y = this.items.findIndex(x => x.item_id === parseInt(this.newItems))
      if (y > -1) {
        if (parseInt(this.itemsPriceType) === 1) {
          this.price = this.items[y].price
          this.itemsPriceTypeStr = 'كاش'
        } else if (parseInt(this.itemsPriceType) === 2) {
          this.price = this.items[y].installment_price
          this.itemsPriceTypeStr = 'قسط'
        } else if (parseInt(this.itemsPriceType) === 3) {
          this.price = this.items[y].used_price
          this.itemsPriceTypeStr = 'مستعمل'
        } else if (parseInt(this.itemsPriceType) === 4) {
          this.price = this.items[y].warranty_price
          this.itemsPriceTypeStr = 'ضمان'
        } else if (parseInt(this.itemsPriceType) === 5) {
          this.price = 0
          this.itemsPriceTypeStr = 'هدية'
        } else {
          this.price = 0
          this.itemsPriceTypeStr = 'عرض'
        }
        this.$refs.price.select()
      }
    },
    // ======================================================
    addToReceiptItems () {
      let y = this.items.findIndex(x => x.item_id === parseInt(this.newItems))
      if (y > -1) {
        var receiptItemId = 0
        if (this.newItems > 0) {
          receiptItemId = Math.round(Math.random() * 10000000)
          this.receiptItems[this.receiptItems.length] = {}
          this.receiptItems[this.receiptItems.length - 1].id = receiptItemId
          this.receiptItems[this.receiptItems.length - 1].Installation = 1
          this.receiptItems[this.receiptItems.length - 1].delivery = 1
          this.receiptItems[this.receiptItems.length - 1].type = 0
          this.receiptItems[this.receiptItems.length - 1].price = this.price
          this.receiptItems[this.receiptItems.length - 1].paid = this.paid
          this.receiptItems[this.receiptItems.length - 1].item = this.items[y].item
          this.receiptItems[this.receiptItems.length - 1].item_id = this.items[y].id
          this.receiptItems[this.receiptItems.length - 1].price_type_id = this.itemsPriceType
          this.receiptItems[this.receiptItems.length - 1].price_type = this.itemsPriceTypeStr
          this.receiptItems[this.receiptItems.length - 1].receipt_item_id = 0
          this.receiptItems[this.receiptItems.length - 1].isContractMaintenanceItems = []
          this.newItems = ''
          this.price = ''
          this.paid = ''
          this.$refs.maintenanceItems.focus()
        }
      }
    },
    // ==================================================================
    selectInstallation (id) {
      for (let c = 0; c < this.receiptItems.length; c++) {
        this.receiptItems[c].Installation = event.target.checked
        /*
        if (event.target.checked === true) {
          this.receiptItems[c].delivery = event.target.checked
          this.selectedDelivery = true
        }
        */
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectDelivery (id) {
      for (let c = 0; c < this.receiptItems.length; c++) {
        this.receiptItems[c].delivery = event.target.checked
        /*
        if (event.target.checked === false) {
          this.receiptItems[c].Installation = event.target.checked
          this.selectedInstallation = false
        }
        */
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectItemInstallation (id, i) {
      if (event.target.checked === true) {
        // let c = this.receiptItems.findIndex(x => x.id === parseInt(i))
        // this.receiptItems[c].delivery = event.target.checked
        this.selectedInstallation = false
        // this.selectedDelivery = false
      }
      this.$forceUpdate()
    },
    // ==================================================================
    selectItemDelivery (id, i) {
      if (event.target.checked === false) {
        // let c = this.receiptItems.findIndex(x => x.id === parseInt(i))
        // this.receiptItems[c].Installation = event.target.checked
        // this.selectedInstallation = false
        this.selectedDelivery = false
      }
      this.$forceUpdate()
    },
    // ======================================================
    getItems () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'get-branch-item-prices', {
        token: localStorage.getItem('token'),
        branch: this.branche_id
      })
        .then(({ data }) => {
          this.items = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
          this.validationErrors = err.response.data.errors
        })
    },
    // ======================================================
    FillGrid () {
      this.records = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-folder-receipt', {
        token: localStorage.getItem('token'),
        collector_id: this.collector_id,
        sort: 'cash_receipts.id',
        folder_date: this.dayDate
      })
        .then(({ data }) => {
          if (data.length > 0) {
            this.records = data
          }
          this.isLoadingData = false
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ======================================================
    GetData (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.newEntry()
        evt.preventDefault()
        this.getReceiptData()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ========================================================
    getReceiptData () {
      this.record = []
      this.isLoadingRecData = true
      this.CustomerDataErr = null
      axios.post(this.$apiURL + 'getReceiptData', {
        token: localStorage.getItem('token'),
        id: this.recID,
        branche_id: this.branche_id
      })
        .then(({ data }) => {
          this.ContractMaintenanceItems = data.ContractMaintenanceItems
          for (let i = 0; i < data.Items.length; i++) {
            let y = this.ContractMaintenanceItems.map(record => record.item_id).indexOf(data.Items[i].item_id)
            if (y > -1 && data.Items[i].type !== 1) {
              data.Items[i].isContractMaintenanceItems = this.ContractMaintenanceItems[y]
              data.Items[i].tooltip = 0
            } else {
              data.Items[i].isContractMaintenanceItems = []
            }
            data.Items[i].id = i + 1
            if (data.Items[i].type === 1 || data.Items[i].type === 10) {
              data.Items[i].price = 'عرض'
              data.Items[i].price_type = 'عرض'
              data.Items[i].price_type_id = 'عرض'
            }
          }
          // -------------
          this.contract_offers = data.ContractOffers
          this.contract_offers.unshift({id: 0, offer_name: 'بدون عرض'})
          this.contract_id = data.data.contract_id
          this.customer_id = data.data.cu_id
          this.folderDate = data.data.folder_date
          this.teller_user_id = data.data.user_id
          this.technical_id = data.data.technical_id
          this.receiptItemSheet = data.ReceiptItems
          this.updateTrSt()
          for (let i = this.receiptItemSheet.length - 1; i >= 0; i--) {
            if (this.receiptItemSheet[i].type === 1) {
              this.receiptItemSheet[i].offer_teller_user_id = data.data.user_id
              if (this.receiptItemSheet[i].price_type === 'قسط') {
                this.receiptItemSheet[i].price_type_id = 2
              } else {
                this.receiptItemSheet[i].price_type_id = 1
              }
            }
            if (this.receiptItemSheet[i].type === 3) {
              this.val1 = this.receiptItemSheet[i].price
            }
          }
          // -------------
          this.record = data.data
          this.isLoadingRecData = false
          this.alert_class = 'alert alert-success'
          this.receiptItems = data.Items
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.CustomerDataErr = err.response.data.errors[0]
          this.isLoadingRecData = false
          this.alert_class = 'alert alert-danger alert-dismissable'
        })
    },
    // ========================================================
    removeItem (rec, type) {
      if (type === 1) {
        for (let c = 0; c < 20; c++) {
          let i = this.receiptItems.map(record => record.receipt_item_id).indexOf(rec.id)
          if (i > -1) {
            this.receiptItems.splice(i, 1)
          }
        }
        let r = this.receiptItemSheet.map(record => record.id).indexOf(rec.id)
        this.receiptItemSheet.splice(r, 1)
      } else {
        let r = this.receiptItems.map(record => record.id).indexOf(rec.id)
        this.receiptItems.splice(r, 1)
      }
    },
    onChangeStore (e) {
      this.updateTrSt()
      if (e.target.options.selectedIndex > -1) {
        this.store_name = e.target.options[e.target.options.selectedIndex].vlaue
      }
    },
    // ============================================================
    updateTrSt () {
      let r = this.collectors.map(record => record.id).indexOf(this.technical_id)
      let t = this.treasuries.map(record => record.user_id).indexOf(this.collectors[r].id)
      let s = this.stores.map(record => record.user_id).indexOf(this.collectors[r].id)
      if (t > -1) {
        this.treasury_id = this.treasuries[t].id
      }
      if (s > -1) {
        this.store_id = this.stores[s].id
      }
    },
    // ============================================================
    saveData () {
      let offerContracts = []
      let maintenanceItems = []
      let installmentItems = []
      for (let i = 0; i < this.receiptItemSheet.length; i++) {
        if (this.receiptItemSheet[i].type === 1) {
          let newRec = []
          let offerItems = []
          newRec[newRec.length] = {}
          newRec[newRec.length - 1].id = 0
          newRec[newRec.length - 1].amount = this.receiptItemSheet[i].amount
          newRec[newRec.length - 1].discount = this.receiptItemSheet[i].discount
          newRec[newRec.length - 1].installment_count = this.receiptItemSheet[i].installment_count
          newRec[newRec.length - 1].presenter_date = this.receiptItemSheet[i].presenter_date
          newRec[newRec.length - 1].price = this.receiptItemSheet[i].price
          newRec[newRec.length - 1].contract_id = this.contract_id
          newRec[newRec.length - 1].date = this.dayDate
          newRec[newRec.length - 1].installment = this.receiptItemSheet[i].installment
          newRec[newRec.length - 1].installment_period_monthly = this.receiptItemSheet[i].installment_period_monthly
          newRec[newRec.length - 1].installment_data = this.receiptItemSheet[i].installment_data
          newRec[newRec.length - 1].label = ''
          newRec[newRec.length - 1].notes = ''
          newRec[newRec.length - 1].offer_id = this.receiptItemSheet[i].rec_id
          newRec[newRec.length - 1].paid = this.receiptItemSheet[i].contract_paid
          newRec[newRec.length - 1].price_type = this.receiptItemSheet[i].price_type_id
          newRec[newRec.length - 1].rec_id = this.receiptItemSheet[i].contract_rec_id
          newRec[newRec.length - 1].rest = this.receiptItemSheet[i].rest
          newRec[newRec.length - 1].state = 1
          newRec[newRec.length - 1].store_id = this.store_id
          newRec[newRec.length - 1].tec_user_id = this.technical_id
          newRec[newRec.length - 1].teller_user_id = this.receiptItemSheet[i].offer_teller_user_id
          newRec[newRec.length - 1].treasury_id = this.treasury_id
          newRec[newRec.length - 1].delivery_date = this.dayDate
          newRec[newRec.length - 1].delivery_technical_id = this.technical_id
          newRec[newRec.length - 1].receipt_id = this.recID
          newRec[newRec.length - 1].customer_id = this.customer_id
          newRec[newRec.length - 1].offer_teller_user_id = this.receiptItemSheet[i].offer_teller_user_id
          // -------------------------
          for (let r = 0; r < this.receiptItems.length; r++) {
            if (this.receiptItemSheet[i].id === this.receiptItems[r].receipt_item_id) {
              let newItemsRec = []
              newItemsRec[newItemsRec.length] = {}
              newItemsRec[newItemsRec.length - 1].Installation = this.receiptItems[r].Installation
              newItemsRec[newItemsRec.length - 1].delivery = this.receiptItems[r].delivery
              newItemsRec[newItemsRec.length - 1].id = this.receiptItems[r].id
              newItemsRec[newItemsRec.length - 1].item = this.receiptItems[r].item
              newItemsRec[newItemsRec.length - 1].item_id = this.receiptItems[r].item_id
              offerItems.unshift(newItemsRec[0])
            }
          }
          // -------------------------
          newRec[newRec.length - 1].offerItems = offerItems
          offerContracts.unshift(newRec[0])
        }
      }
      // ===================================================================================
      for (let i = 0; i < this.receiptItems.length; i++) {
        if (this.receiptItems[i].type === 0 || this.receiptItems[i].type === 10) {
          let newRec = []
          newRec[newRec.length] = {}
          newRec[newRec.length - 1].id = maintenanceItems.length
          newRec[newRec.length - 1].contract_id = this.contract_id
          newRec[newRec.length - 1].item_id = this.receiptItems[i].item_id
          newRec[newRec.length - 1].change_date = this.dayDate
          newRec[newRec.length - 1].amount = this.receiptItems[i].price
          newRec[newRec.length - 1].paid = this.receiptItems[i].paid
          newRec[newRec.length - 1].Installation = this.receiptItems[i].Installation
          newRec[newRec.length - 1].delivery = this.receiptItems[i].delivery
          newRec[newRec.length - 1].treasury_id = this.treasury_id
          newRec[newRec.length - 1].technical_id = this.technical_id
          newRec[newRec.length - 1].teller_user_id = this.teller_user_id
          newRec[newRec.length - 1].price_type_id = this.receiptItems[i].price_type_id
          newRec[newRec.length - 1].store_id = this.store_id
          if (this.receiptItems[i].isContractMaintenanceItems.isOk) {
            newRec[newRec.length - 1].old_delivery_technical_id = this.receiptItems[i].isContractMaintenanceItems.delivery_technical_id
            newRec[newRec.length - 1].ContractMaintenanceRec = this.receiptItems[i].isContractMaintenanceItems.id
          } else {
            newRec[newRec.length - 1].old_delivery_technical_id = null
            newRec[newRec.length - 1].ContractMaintenanceRec = 0
          }
          maintenanceItems.unshift(newRec[0])
        }
      }
      // =====================================================================================
      for (let i = 0; i < this.receiptItemSheet.length; i++) {
        if (this.receiptItemSheet[i].type === 11) {
          let newRec = []
          newRec[newRec.length] = {}
          newRec[newRec.length - 1].id = newRec.length
          newRec[newRec.length - 1].rec_id = this.receiptItemSheet[i].rec_id
          newRec[newRec.length - 1].contract_id = this.contract_id
          newRec[newRec.length - 1].receipt_id = this.recID
          // -------------------------
          installmentItems.unshift(newRec[0])
        }
      }
      // ===================================================================================
      this.isLoadingData = true
      axios.post(this.$apiURL + 'saveReceiptData', {
        id: this.recID,
        branche_id: this.branche_id,
        customer_id: this.customer_id,
        treasury_id: this.treasury_id,
        store_id: this.store_id,
        dayDate: this.dayDate,
        technical_id: this.technical_id,
        contract_offer_id: this.contract_offer_id,
        maintenance_expenses: this.val1,
        teller_user_id: this.teller_user_id,
        contract_id: this.contract_id,
        maintenanceItems: maintenanceItems,
        installmentItems: installmentItems,
        installment: this.installment,
        folder_date: this.receipt,
        receipt: this.receipt,
        folderDate: this.folderDate,
        offerContracts: offerContracts,
        tds: this.tds,
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.newEntry()
          this.recID = ''
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
          this.validationReceiptErrors = err.response.data.errors
        })
    },
    // ============================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // ============================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ===========================================================================
    returnDataCustomer () {
      // Dont Delete It ####
    },
    // ===========================================================================
    openCustomerData (uid, rec) {
      this.$refs.CustomerDetails.setData(uid, rec)
    }
    // ============================================================
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/Daily/DailyAccounts.vue